module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('table', {
    staticClass: "table is-striped is-responsive",
    class: {
      'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    attrs: {
      "id": "getBonus"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("trading_account").tUpper()))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("platform").tUpper()))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("amount").tUpper()))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("date").tUpper()))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("status").tUpper()))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("conversion_progress").tUpper()))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.Bonuses), function(bonus) {
    return _c('tr', {
      key: bonus.trading_account
    }, [_c('td', [_vm._v(_vm._s(bonus.trading_account))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bonus.platform))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$formatMoney(bonus.bonusAmount, '')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bonus.dateGranted.substring(0, 16).replace("T", " ")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bonus.status))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "bar"
    }, [_c('div', {
      staticClass: "progressText"
    }, [_vm._v(_vm._s(Math.floor(bonus.conversion_progress)) + "%")]), _vm._v(" "), _c('div', {
      staticClass: "progress",
      style: ('width: ' + Math.floor(bonus.conversion_progress) + '%;')
    })])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd6e4f5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/my-bonuses.vue
// module id = 813
// module chunks = 0